import React from 'react'
import { CancelLink, CustomPayment,Payments, RefundPayment, InfoPayment, NewLink } from './Actions'
/**
* PaymentItem
* @param {object} props
* @param {object} props.plugins
* @param {object} props.user
* @param {string} props.actionSelected
* @param {string} props.filterSelected
* @param {string} props.idOrderSelected
* @param {Function} props.setActionSelected
* @param {Function} props.setIdOrderSelected
* @param {Function} props.setStateInfo
*/

const RenderItemAction = (props) => {
  const { plugins, user, actionSelected, idOrderSelected, setActionSelected, setIdOrderSelected, setStateInfo, filterSelected } = props
  switch (actionSelected) {
    case 'newPayment':
      return (
        <CustomPayment
          plugin={plugins.customPayment}
          tabId="customPayment"
          user={user}
        />
      )
    case 'extended':
      return (
        <NewLink
          plugin={plugins.newLink}
          tabId="newLink"
          user={user}
          orderId={idOrderSelected}
        />
      )
    case 'cancel':
      return (
        <CancelLink
          plugin={plugins.cancelLink}
          tabId="cancelLink"
          user={user}
          orderId={idOrderSelected}
        />
        
      )
    case 'refund':
      return (
        <RefundPayment
          userId={user._id}
          orderId={idOrderSelected}
        />
      )
    case 'info':
      return (
        <InfoPayment
          userId={user._id}
          orderId={idOrderSelected}
        />
      )
    case 'payments':
    default:
      return (
        <Payments 
          userId={user._id} 
          setActionSelected={setActionSelected} 
          setIdOrderSelected={setIdOrderSelected}
          setStateInfo={setStateInfo}
          filterSelected={filterSelected}
        />
      )
  }
}


export default RenderItemAction